var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.areaType === 'COUNTY')?_c('payoffCounty'):_c('payoffCity')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }